import { Loading } from "src/components/utils/Loading";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ChartMode, ScoreDetailChartData } from "../../Chart/chart.types";
import { ScoreDetailChartBox } from "../../Chart";
import { ModalData } from "../../PropertyModal/PropertyModal";
import { propertyActionRuleset } from "./Common/propertyActionRuleset";

type ByHeadingProps = {
    headingId: number;
    openModal: (property: ModalData) => void;
    mode: ChartMode;
};
export const ByHeading = (props: ByHeadingProps) => {
    const { scoreDetailBuilder, drilldownState } = useScoreDetailContext();
    if (scoreDetailBuilder === undefined) {
        return <Loading />;
    }

    const { headingId, mode, openModal } = props;

    const byHeading = scoreDetailBuilder.getByHeadingId({ headingId });
    if (byHeading === null) {
        return;
    }

    const headingItems: ScoreDetailChartData[] = [];
    const withSubheadings =
        byHeading?.subheadings.reduce((acc, subheading) => {
            const subheadingScore = subheading.score.value;
            if (subheadingScore === null) return acc;

            const newSubheadingItem: ScoreDetailChartData = {
                title: subheading.title,
                score: subheading.score,
                action: () => {
                    drilldownState.drilldown({
                        id: subheading.id,
                        label: subheading.title,
                        type: "subheadings",
                    });
                },
            };
            acc.push(newSubheadingItem);

            return acc;
        }, headingItems) ?? [];

    const withProperties = byHeading?.properties?.reduce((acc, property) => {
        const propertyScore = property.score?.value;
        if (propertyScore === null || propertyScore === undefined || propertyScore === 0) {
            return acc;
        }
        if (property.score === null) return acc;

        const action = propertyActionRuleset({
            property,
            mode,
            openModal,
            drilldown: drilldownState.drilldown,
        });
        const newPropertyItem: ScoreDetailChartData = {
            title: property.property.title ?? "",
            score: property.score,
            action,
        };
        acc.push(newPropertyItem);

        return acc;
    }, withSubheadings);

    const total: ScoreDetailChartData = {
        title: "Total",
        score: byHeading?.total,
    };

    return <ScoreDetailChartBox data={withProperties ?? []} total={total} mode={mode} />;
};
